import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import SessionTimeoutWarning from './SessionTimeoutWarning';

const SessionManager: React.FC = () => {
  const { isSessionExpiring, extendSession, logout } = useAuth();

  return (
    <SessionTimeoutWarning
      isVisible={isSessionExpiring}
      onExtendSession={extendSession}
      onLogout={logout}
    />
  );
};

export default SessionManager;